<template>
    <div class="animated fadeIn">
        <section class="section">
            <div class="">
                <div class="columns is-centered">
                    <div class="column intro-text content is-mobile">
                        <h3 class="is-size-3 small-container padding-bottom-1x uptin-text-center">
                            {{ $t('home:our_customers.title') }}
                        </h3>
                    </div>
                </div>
                <div class="columns">
                    <div class="column intro-text content small-container">
                        <p class="is-size- small-container uptin-text-center uptin-text-7">
                            {{ $t('home:our_customers.description') }}
                        </p>
                    </div>
                </div>
                <div class="columns is-centered featured-in has-padding-2x">
                    <div class="logo">
                        <a
                           class="featured-in__logo-wrapper"
                           target="_blank" rel="noopener noreferrer">
                            <figure class="image">
                                <img class="is-grayscale" src="./assets/logo-1.png">
                            </figure>
                        </a>
                    </div>
                    <div class="logo">
                        <a
                           class="featured-in__logo-wrapper"
                           target="_blank" rel="noopener noreferrer">
                            <figure class="image">
                                <img class="is-grayscale" src="./assets/logo-2.png">
                            </figure>
                        </a>
                    </div>
                    <div class="logo">
                        <a
                           class="featured-in__logo-wrapper"
                           target="_blank" rel="noopener noreferrer">
                            <figure class="image">
                                <img class="is-grayscale" src="./assets/logo-3.png">
                            </figure>
                        </a>
                    </div>
                    <div class="logo">
                        <a
                           class="featured-in__logo-wrapper"
                           target="_blank" rel="noopener noreferrer">
                            <figure class="image">
                                <img class="is-grayscale" src="./assets/logo-4.png">
                            </figure>
                        </a>
                    </div>
                    <div class="logo">
                        <a
                           class="featured-in__logo-wrapper"
                           target="_blank" rel="noopener noreferrer">
                            <figure class="image">
                                <img class="is-grayscale" src="./assets/logo-6.png">
                            </figure>
                        </a>
                    </div>
                    <div class="logo">
                        <a
                           class="featured-in__logo-wrapper"
                           target="_blank" rel="noopener noreferrer">
                            <figure class="image">
                                <img class="is-grayscale" src="./assets/logo-11.png">
                            </figure>
                        </a>
                    </div>
                    <div class="logo">
                        <a
                           class="featured-in__logo-wrapper"
                           target="_blank" rel="noopener noreferrer">
                            <figure class="image">
                                <img class="is-grayscale" src="./assets/logo-12.png">
                            </figure>
                        </a>
                    </div>
                    <div class="logo">
                        <a
                           class="featured-in__logo-wrapper"
                           target="_blank" rel="noopener noreferrer">
                            <figure class="image">
                                <img class="is-grayscale" src="./assets/logo-7.png">
                            </figure>
                        </a>
                    </div>
                    <div class="logo">
                        <a
                           class="featured-in__logo-wrapper"
                           target="_blank" rel="noopener noreferrer">
                            <figure class="image">
                                <img class="is-grayscale" src="./assets/logo-8.png">
                            </figure>
                        </a>
                    </div>
                    <div class="logo">
                        <a
                           class="featured-in__logo-wrapper"
                           target="_blank" rel="noopener noreferrer">
                            <figure class="image">
                                <img class="is-grayscale" src="./assets/logo-9.png">
                            </figure>
                        </a>
                    </div>
                    <div class="logo">
                        <a
                           class="featured-in__logo-wrapper"
                           target="_blank" rel="noopener noreferrer">
                            <figure class="image">
                                <img class="is-grayscale" src="./assets/logo-10.png">
                            </figure>
                        </a>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<style lang="scss">
    .logo {
        display: flex;
        justify-content: center;
        margin-top: 1rem;
        margin-bottom: 1rem;

        @media screen and (max-width: 769px) {
            min-height: 6em;
        }
    }

    .featured-in {
        .is-grayscale {

            &:hover {
                filter: none;
            }
        }

        &__small {
            .image {
                max-width: 10em;
            }
        }
    }

    .featured-in__logo-wrapper {
        width: 60%;
        display: flex;
        align-items: center;
    }

    .featured-in-img {
        max-width: 128px;
        height: auto;

        &.position-top {
            top: -1em;
        }
    }

    .featured-in-img-2 {
        max-width: 200px;
        height: auto;

        &.position-top {
            top: -1em;
        }
    }

    .featured-in-img-3 {
        max-width: 110px;
        height: auto;

        &.position-top {
            top: -1em;
        }
    }
</style>
<script>
    export default {
        name: "customers.vue",
    }


</script>
